import Skeleton from '@mui/material/Skeleton';
import { Stack } from 'shared/mui/Stack/Stack';

export const CommissionsShowSkeleton = () => {
  return (
    <Stack gap="24px">
      <Skeleton height={24} variant="rounded" width="100%" />
      <Skeleton height={48} variant="rounded" width="100%" />
      <Skeleton height={246} variant="rounded" width="100%" />
    </Stack>
  );
};
